var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-100 d-flex align-items-center justify-content-center",
      class: {
        "full-page-loader": _vm.isFullPage
      }
    },
    [_c("b-spinner", { staticClass: "my-5", attrs: { type: "grow" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }